type Translations = Record<string, string> | null | undefined

interface TranslationHelpers {
  getTranslatedText: (translations: Record<string, string>) => unknown
}

/**
 * Task text in the user locale, falling back to fr_BE (e.g. a fr_FR user on fr_BE-only
 * data). Shared by the task card and the list view.
 */
export const taskDisplayName = (
  translations: Translations,
  helpers: TranslationHelpers
): string => {
  if (!translations) {
    return ''
  }
  const text = helpers.getTranslatedText(translations)
  return typeof text === 'string' ? text : ''
}
